(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["handmen-collection-filter-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    const form = input.closest('.handmen-filter-bar__form');
    if (!form) return;
    if (input.type === 'checkbox') form.submit();
  });
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('.handmen-filter-link');
    if (link) {
      event.preventDefault();
      const param = link.getAttribute('data-filter-param');
      const value = link.getAttribute('data-filter-value');
      if (!param || !value) return;
      const url = new URL(window.location.href);
      url.searchParams.delete('page');
      if (url.searchParams.getAll(param).includes(value)) url.searchParams.delete(param, value);
      else url.searchParams.append(param, value);
      window.location.href = url.toString();
      return;
    }
    document.querySelectorAll('.handmen-filter-menu[open]').forEach((menu) => { if (!menu.contains(event.target)) menu.removeAttribute('open'); });
  });
  document.addEventListener('DOMContentLoaded', () => {
    const params = new URL(window.location.href).searchParams;
    document.querySelectorAll('.handmen-filter-link').forEach((link) => {
      if (!(link instanceof HTMLElement)) return;
      const param = link.getAttribute('data-filter-param');
      const value = link.getAttribute('data-filter-value');
      if (!param || !value) return;
      if (params.getAll(param).includes(value)) {
        link.classList.add('is-active');
        const summary = link.closest('.handmen-filter-menu')?.querySelector('summary');
        if (summary && !summary.querySelector('em')) {
          const badge = document.createElement('em');
          badge.textContent = String(params.getAll(param).length);
          summary.appendChild(badge);
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
